import { useState } from "react";
import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import DocumentDrawer from "components/bid_module/DocumentDrawer";
import { Scorecard_Result_Questions_Sources_Locations } from "lib/generated/app-service-gql/graphql";
import { EventNames, useTracking } from "lib/tracking";
import { CustomerDocumentDrawer } from "../../content_library/CustomerDocumentDrawer";
import { AiDocumentSource } from "../types";

type Props = {
  source: AiDocumentSource;
};

export default function DocumentSource({ source }: Props) {
  const { logEvent } = useTracking();

  const [isDocumentDrawerOpen, setIsDocumentDrawerOpen] = useState(false);

  const handleSourceClick = () => {
    setIsDocumentDrawerOpen(true);
    logEvent(EventNames.citationOpened, {
      "Action type": "Document source clicked",
      "Criteria name": "Ai assistant",
    });
  };

  const locations = source.locations || [];
  const locationCount = locations.length;
  return (
    <>
      <Flex column gap={8}>
        <Text bold>{source.title}</Text>
        {/* TODO: Add document path and snippet */}
        <MentionsText onClick={handleSourceClick}>
          {locationCount === 1 ? "View source" : `${locationCount} mentions`}
        </MentionsText>
      </Flex>
      {source.documentType === "CONTENT_LIBRARY" ? (
        <CustomerDocumentDrawer
          source={{
            documentId: source.id,
            fileName: source.title,
            locations: source.locations as Scorecard_Result_Questions_Sources_Locations[],
          }}
          onClose={() => setIsDocumentDrawerOpen(false)}
          isOpen={isDocumentDrawerOpen}
        />
      ) : (
        <DocumentDrawer
          open={isDocumentDrawerOpen}
          onClose={() => setIsDocumentDrawerOpen(false)}
          source={{
            documentId: source.id,
            fileName: source.title,
            chunkNumber: source.chunkNumber,
            locations: source.locations as Scorecard_Result_Questions_Sources_Locations[],
          }}
          documentType={source.documentType}
        />
      )}
    </>
  );
}

const MentionsText = styled(Text)(({ theme }) => ({
  color: theme.colors.sysPrimaryDefault,
  cursor: "pointer",
}));
